import React from 'react'
import { AnyBlock, BlockRendererProps, BlockSettingsMap } from './types'
import { defaultBlockRegistry } from './registry'

export const BlockRenderer = <M extends BlockSettingsMap>({
  blocks,
  registry = defaultBlockRegistry,
  onUnknownType,
}: BlockRendererProps<M>): JSX.Element => {
  return (
    <>
      {blocks.map((block: AnyBlock<M>, index) => {
        const { blocks, settings, type } = block as AnyBlock<M>
        const Component = registry[type]
        if (!Component) {
          console.warn(`Unknown block type: ${type}`)
          return onUnknownType ? onUnknownType(type, block, index) : null
        }
        return <Component key={index} blocks={blocks} {...(settings as any)} />
      })}
    </>
  )
}

export default BlockRenderer
